<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="placa"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Placa</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="renavam"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Renavam</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_veiculo"
              :options="optionsLivTpVeiculo"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_situacao"
              :options="this.optionsTpSituacao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Situação"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data expiração Inicial"
              v-model="dt_expiracao_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Data expiração Final"
              v-model="dt_expiracao_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
              @keyup.enter="doFilter"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="param_tp_veiculo"
              :options="optionsParamTpVeiculo"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tração/Reboque"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from 'moment'
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      helpForm: new Form({ params: [] }),
      placa: "",
      renavam: "",
      optionsLivStatus: [],
      optionsTpSituacao: [],
      optionsLivTpVeiculo: [],
      optionsParamTpVeiculo: [],
      status: [],
      dt_expiracao_ini: "",
      dt_expiracao_fim: "",
      dt_expiracao_ini_label: "",
      dt_expiracao_fim_label: "",
      tp_situacao: "",
      tp_veiculo: [],
      param_tp_veiculo: [],
      data_filter: []
    };
  },
  mounted() {
    this.getListItemGeral();
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.dt_expiracao_ini_label = this.dt_expiracao_ini;
      this.dt_expiracao_fim_label = this.dt_expiracao_fim;
      this.dt_expiracao_ini = this.formatDateSubmit(this.dt_expiracao_ini);
      this.dt_expiracao_fim = this.formatDateSubmit(this.dt_expiracao_fim);
      this.data_filter = {
        placa: this.placa,
        renavam: this.renavam,
        tp_situacao: this.tp_situacao,
        dt_expiracao_ini: this.dt_expiracao_ini,
        dt_expiracao_fim: this.dt_expiracao_fim,
        status: this.status,
        tp_veiculo: this.tp_veiculo,
        param_tp_veiculo: this.param_tp_veiculo
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_expiracao_ini = this.dt_expiracao_ini_label;
      this.dt_expiracao_fim = this.dt_expiracao_fim_label;
    },
    resetFilter() {
      this.placa = ""; // clear the text in text input
      this.renavam = "";
      this.status = "";
      this.tp_veiculo = "";
      this.dt_expiracao_ini = "";
      this.dt_expiracao_fim = "";
      this.tp_situacao = "";
      this.param_tp_veiculo = "";
      this.$events.fire("filter-reset");
    },
    formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
      return (value == null || value == "")
          ? ''
          : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
    getListItemGeral() {
      this.helpForm
        .post("/api/veiculo/jsonlistfiltros")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });

          response.tp_veiculo.forEach(obj => {
            this.optionsLivTpVeiculo.push({
              label: obj.descr,
              value: obj.valor
            });
          });

          response.param_tipo_veiculo.forEach(obj => {
            this.optionsParamTpVeiculo.push({
              label: obj.descr,
              value: obj.partipvei_id
            });
          });

          response.tp_situacao.forEach((obj) => {
            this.optionsTpSituacao.push({
              label: obj.descr, 
              value: obj.valor,
            });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, false, false);
        });
    }
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      }
    }
  }
};
</script>
